export default [{
	path: 'assetLedger',
	component: () => import('../../sys/assetLedger/index'),
	redirect: '/sys/assetLedger/room',
	children: [{
			path: 'room',
			component: () => import('../../sys/assetLedger/room'),
			meta: {
				title: '（实训室档案）后台管理'
			}
		},
		{
			path: 'asset',
			component: () => import('../../sys/assetLedger/asset'),
			meta: {
				title: '（资产台账）后台管理'
			}
		},
		{
			path: 'stock',
			component: () => import('../../sys/assetLedger/stock'),
			meta: {
				title: '（出入库管理）后台管理'
			}
		},
	]
}]
